import React from "react";
import { Box, Button } from "@mui/material";
import Alert from "@mui/material/Alert";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { Add, Launch, Print } from "@mui/icons-material";
import { useSelector } from "react-redux";
import { Tooltip } from "../../../../components/Tooltip";
import LoadingButton from "../../../../components/Buttons/LoadingButton";
import ButtonGroup from "../../../../components/Buttons/ButtonGroup";

const ProcessingVideoNote = ({ processingVideos }) => {
  const { t } = useTranslation();
  const vidMsg = (
    <Box mb={2}>
      <Alert severity="info">
        {t("videoProcessing.deploy", {
          title: processingVideos
            .map(processingVideo => processingVideo.title)
            .join(", ")
        })}
      </Alert>
    </Box>
  );
  return vidMsg;
};

const PolicyVersionDetailsButtonsHeader = ({
  releasePending,
  onPreviewClick,
  onCreateReleaseClick,
  releaseDisabled,
  disabled,
  processingVideos
}) => {
  const { t } = useTranslation();
  const getReleaseButton = () => {
    return releaseDisabled ? (
      <Box display="flex">
        <Tooltip title={t("courseVersion.details.policyReleaseButtonDisabled")}>
          <div>
            <LoadingButton
              pending={isCreatingNewRelease}
              startIcon={<Add />}
              disabled={true}
              size="large"
              color="primary"
              onClick={onCreateReleaseClick}
            >
              {t("courseVersion.details.createBtn")}
            </LoadingButton>
          </div>
        </Tooltip>
      </Box>
    ) : (
      <Box display="flex">
        <LoadingButton
          pending={isCreatingNewRelease}
          startIcon={<Add />}
          disabled={disabled}
          size="large"
          color="primary"
          onClick={onCreateReleaseClick}
        >
          {t("courseVersion.details.createBtn")}
        </LoadingButton>
      </Box>
    );
  };

  const { isCreatingNewRelease } = useSelector(
    ({ contentCoursesState: { isCreatingNewRelease } }) => ({
      isCreatingNewRelease
    })
  );

  return (
    <>
      {processingVideos.length ? (
        <ProcessingVideoNote processingVideos={processingVideos} />
      ) : (
        <></>
      )}
      <Box
        display="flex"
        justifyContent="flex-end"
        mt={2}
        mb={2}
        flexDirection={{ xs: "column", sm: "row" }}
        flexWrap="wrap"
        alignItems="flex-start"
      >
        <ButtonGroup align="left" flexWrap="wrap">
          <Button
            startIcon={<Launch />}
            onClick={onPreviewClick}
            color="primary"
            size="large"
            disabled={disabled}
          >
            {t("courseVersion.details.previewBtn")}
          </Button>
          <Button
            startIcon={<Print />}
            onClick={() => {}}
            color="primary"
            size="large"
            disabled={disabled}
          >
            {t("courseVersion.details.printPolicyBtn")}
          </Button>
          {!releasePending && getReleaseButton()}
        </ButtonGroup>
      </Box>
    </>
  );
};

export default PolicyVersionDetailsButtonsHeader;

PolicyVersionDetailsButtonsHeader.propTypes = {
  onCreateReleaseClick: PropTypes.func,
  onPreviewClick: PropTypes.func,
  disabled: PropTypes.bool,
  releaseDisabled: PropTypes.bool,
  releasePending: PropTypes.bool
};
